import axios from '@/utils/http';

export default (page, per_page) => {
  let url = `/advertisement_notice?page=${page}&per_page=${per_page}`;
  return axios
    .get(url)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
